import { ReactNode } from 'react';
import { useImportConfiguration } from 'src/context/import-configuration';

import { ImportDraftGlobalProvider } from './import-draft-global-provider';
import { ImportWizardFlowBridge } from './import-wizard-flow-bridge';

type Props = {
  /** Step 3+ use draft global + React Flow for dialogs */
  step: number;
  children: ReactNode;
};

export function ImportWizardStepShell({ step, children }: Props) {
  const { dialogState } = useImportConfiguration();
  const pj = dialogState?.projectJsonData;

  if (!pj || step < 3) {
    return <>{children}</>;
  }

  return (
    <ImportDraftGlobalProvider projectJsonData={pj}>
      <ImportWizardFlowBridge projectJsonData={pj}>
        {children}
      </ImportWizardFlowBridge>
    </ImportDraftGlobalProvider>
  );
}
